// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flex[data-v-5f219cce] {\n  display: flex;\n}\n.cardContentT[data-v-5f219cce] {\n  height: 100%;\n}\n.cardContentT .chart[data-v-5f219cce] {\n  position: relative;\n  height: 100%;\n}\n.choseType[data-v-5f219cce] {\n  margin: 0 0.05208rem;\n  font-size: 0.06771rem;\n  cursor: pointer;\n  border-bottom: 2px solid transparent;\n  color: #00e2fb;\n}\n.select[data-v-5f219cce] {\n  color: #ffd400;\n  border-bottom: 2px solid;\n}\n", ""]);
// Exports
module.exports = exports;
